import { Typography } from './typography'
import { IconChevronRight } from '@tabler/icons-react'
import classes from './PlatformPicker.module.css'

export interface Platform {
  platform_id: number
  platform_name: string
}

interface Props {
  platforms: Platform[]
  onSelect: (platformId: number) => void
}

export default function PlatformPicker({ platforms, onSelect }: Props) {
  return (
    <div className={classes.platformContainer}>
      <Typography
        level={2}
        fw={500}
        lh="125"
        ta="center"
        fc={{ light: 'white', dark: 'white' }}
      >
        Select Platform
      </Typography>
      <div className={classes.platformsWrapper}>
        {platforms.map((platform) => (
          <div
            key={platform.platform_id}
            className={classes.platformRow}
            onClick={() => onSelect(platform.platform_id)}
          >
            <Typography
              fs="sm"
              lh="115"
              fc={{ light: 'gray-7', dark: 'gray-7' }}
            >
              {platform.platform_name}
            </Typography>
            <IconChevronRight className={classes.platformIcon} />
          </div>
        ))}
      </div>
    </div>
  )
}
